import { RouterView } from 'vue-router'
import { AppContext } from './AppContext'
import { doubleMSocketService, exchangeSocketService, useBaseInfoStore, useEnvStore, useIpRestrictStore, useLanguageStore, useResponsive } from 'store'
import { PageRoutes } from './constants/PageRoutes'
import { PLATFORM_CONFIG } from 'platform-config'
import { useI18n } from 'i18n-utils'
import { StorageKeys } from 'store/src/constants/static-table-sv-id'
import { firstCharToUpper, getQueryParams } from 'utils'
import { ElConfigProvider } from 'element-plus'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import { PageLayout } from './layouts/Page.layout'
import { APP_CONFIG } from './project-config'
import { getElementPlusLang } from './constants/ElementPlusLangConfig.ts'
import { servicesInterceptor } from './interceptor/services.ts'
import { FooterAppDownload } from './components/FooterAppDownload.tsx'

/** IP 受限时允许访问的路由白名单 */
const ipRestrictWhitelist = [PageRoutes.Home, PageRoutes.LegalCompliance]

const App = defineComponent({
  setup() {
    const route = useRoute()
    const router = useRouter()
    useEnvStore()
    servicesInterceptor()
    useResponsive()
    const ipRestrictStore = useIpRestrictStore()

    // 监听 IP 限制状态变化，受限时跳转到首页
    watch(
      () => ipRestrictStore.isIpRestricted,
      (restricted) => {
        if (restricted && !ipRestrictWhitelist.includes(route.path as PageRoutes)) {
          router.replace(PageRoutes.Home)
        }
      }
    )

    const { t } = useI18n()

    useBaseInfoStore()

    const languageStore = useLanguageStore()

    const initialize = () => {
      const ico = document.getElementById('ico')
      const query = getQueryParams()
      if (query.lang) {
        window.localStorage.setItem(StorageKeys.CurrentLanguage, query.lang as string)
      }
      if (ico) {
        ico.setAttribute('href', PLATFORM_CONFIG.ico)
      }
    }

    onBeforeMount(() => {
      initialize()
    })

    watchEffect(() => {
      const title = route.meta.title
      if (title) {
        document.title = firstCharToUpper(t(title as string))
      }
    })

    onDeactivated(() => {
      exchangeSocketService.dispose()
      doubleMSocketService.dispose()
    })

    const locale = computed(() => getElementPlusLang(languageStore.currentLanguage))

    onBeforeMount(() => {})

    return () => (
      <ElConfigProvider locale={locale.value}>
        <PageLayout>
          <>
            {APP_CONFIG.Header && <APP_CONFIG.Header />}
            <AppContext>
              <RouterView />
            </AppContext>
          </>
          {APP_CONFIG.Footer && <APP_CONFIG.Footer />}
          <FooterAppDownload />
        </PageLayout>
      </ElConfigProvider>
    )
  },
})

export default App
